document.addEventListener('DOMContentLoaded', function () {

  // --- Shared helpers ---

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getUKDateInfo() {
    var now = new Date();

    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      weekday: 'long',
      hour12: false
    });

    var parts = formatter.formatToParts(now);
    var h = 0, m = 0, s = 0, weekday = '';
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'hour')    h       = parseInt(parts[i].value, 10);
      if (parts[i].type === 'minute')  m       = parseInt(parts[i].value, 10);
      if (parts[i].type === 'second')  s       = parseInt(parts[i].value, 10);
      if (parts[i].type === 'weekday') weekday = parts[i].value; // e.g. 'Saturday'
    }

    return { h: h, m: m, s: s, weekday: weekday };
  }

  function getSecondsRemaining() {
    var info = getUKDateInfo();
    var secondsSinceMidnight = info.h * 3600 + info.m * 60 + info.s;
    var cutoffSeconds = 15 * 3600; // 3:00pm
    return cutoffSeconds - secondsSinceMidnight;
  }

  // Returns the delivery day label to show the customer.
  // On Saturday, next-day would be Sunday (no delivery), so we say Monday.
  function getDeliveryDayLabel() {
    var weekday = getUKDateInfo().weekday;
    return weekday === 'Saturday' ? 'Monday' : 'next day';
  }

  function isSunday() {
    return getUKDateInfo().weekday === 'Sunday';
  }

  function formatTime(secs) {
    var h = Math.floor(secs / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = secs % 60;
    return h > 0
      ? (h + ':' + pad(m) + ':' + pad(s))
      : (pad(m) + ':' + pad(s));
  }

  // --- Out of stock check ---

  function isProductSoldOut() {
    var addToCartText = document.querySelector('span.add-to-cart-text__content');
    if (!addToCartText) return false;
    var spans = addToCartText.querySelectorAll('span span');
    for (var i = 0; i < spans.length; i++) {
      if (spans[i].textContent.trim() === 'Sold out') return true;
    }
    return false;
  }

  // --- Buy button banner ---

  var buyTarget = document.querySelector('#MainContent[data-template="product"] .buy-buttons-block');
  if (buyTarget) {

    var banner = document.createElement('div');
    banner.className = 'dc-ndd-banner';
    banner.id = 'dc-ndd-countdown-banner';
    buyTarget.insertAdjacentElement('afterend', banner);

    if (isProductSoldOut()) {
      var soldOutMsg = document.createElement('p');
      soldOutMsg.className = 'dc-oos-notice-text';
      soldOutMsg.innerHTML = 'Out of stock? <a href="https://homesmartonline.co.uk/pages/contact-us">We can source it, just ask.</a>';
      buyTarget.insertAdjacentElement('afterend', soldOutMsg);
    }

  }

  function renderSunday() {
    var b = document.getElementById('dc-ndd-countdown-banner');
    if (!b) return;
    b.classList.remove('dc-ndd-urgent');
    b.innerHTML = [
      '<span class="dc-ndd-icon">🚚</span>',
      '<div>',
        '<p class="dc-ndd-expired-msg">Order before 3:00pm Monday for next day delivery</p>',
      '</div>'
    ].join('');
  }

  function renderExpired() {
    var b = document.getElementById('dc-ndd-countdown-banner');
    if (!b) return;
    var dayLabel = getDeliveryDayLabel();
    b.classList.remove('dc-ndd-urgent');
    b.innerHTML = [
      '<span class="dc-ndd-icon">🚚</span>',
      '<div>',
        '<p class="dc-ndd-expired-msg">Order before 3:00pm for ' + dayLabel + ' delivery</p>',
      '</div>'
    ].join('');
  }

  function renderCountdown(secs) {
    var b = document.getElementById('dc-ndd-countdown-banner');
    if (!b) return;
    var dayLabel = getDeliveryDayLabel();
    var display = document.getElementById('dc-ndd-timer-display');
    var cutoff = document.getElementById('dc-ndd-cutoff-text');

    if (!display) {
      b.innerHTML = [
        '<span class="dc-ndd-icon">🚚</span>',
        '<div>',
          '<span class="dc-ndd-label">Order within</span>',
          '<span class="dc-ndd-timer" id="dc-ndd-timer-display">\u2013:\u2013\u2013:\u2013\u2013</span>',
          '<p class="dc-ndd-cutoff" id="dc-ndd-cutoff-text">for ' + dayLabel + ' delivery (cutoff 3:00pm)</p>',
        '</div>'
      ].join('');
    } else {
      display.textContent = formatTime(secs);
      // Keep the day label in sync in case the page spans midnight into Saturday
      if (cutoff) cutoff.textContent = 'for ' + dayLabel + ' delivery (cutoff 3:00pm)';
    }

    b.classList.toggle('dc-ndd-urgent', secs < 3600);
  }

  // --- Notice bar countdown ---

  var noticeTarget = document.querySelector('p.announcement-bar__text');
  if (noticeTarget) {
    var noticeSpan = document.createElement('span');
    noticeSpan.className = 'dc-notice-bar-countdown';
    noticeSpan.id = 'dc-notice-bar-countdown';
    noticeTarget.insertAdjacentElement('afterend', noticeSpan);
  }

  function updateNoticeBar(secs) {
    var el = document.getElementById('dc-notice-bar-countdown');
    if (!el) return;
    if (isSunday()) {
      el.textContent = 'Order before 3:00pm Monday for next day delivery';
      return;
    }
    var dayLabel = getDeliveryDayLabel();
    if (secs <= 0) {
      el.textContent = 'Order by 3:00pm for ' + dayLabel + ' delivery';
    } else {
      el.textContent = 'Order within ' + formatTime(secs) + ' for ' + dayLabel + ' delivery';
    }
  }

  // --- Tick ---

  function tick() {
    if (isSunday()) {
      renderSunday();
      updateNoticeBar(0);
      return;
    }
    var secs = getSecondsRemaining();
    if (secs <= 0) {
      renderExpired();
    } else {
      renderCountdown(secs);
    }
    updateNoticeBar(secs);
  }

  tick();
  setInterval(tick, 1000);

  // --- Sale saving amount ---

  function parsePriceText(text) {
    var cleaned = text.replace(/[^0-9.]/g, '');
    return parseFloat(cleaned);
  }

  function formatSaving(amount) {
    return '\u00a3' + amount.toFixed(2);
  }

  var saleTarget = document.querySelector('#MainContent[data-template="product"] .product-details .price__sale');
  if (saleTarget) {
    var saleEl = saleTarget.querySelector('.price-item--sale');
    var regularEl = saleTarget.querySelector('.price-item--regular');

    if (saleEl && regularEl) {
      var salePrice = parsePriceText(saleEl.textContent);
      var regularPrice = parsePriceText(regularEl.textContent);

      if (!isNaN(salePrice) && !isNaN(regularPrice) && regularPrice > salePrice) {
        var saving = regularPrice - salePrice;
        var savingMsg = document.createElement('p');
        savingMsg.className = 'dc-sale-saving-amount';
        savingMsg.textContent = 'You save ' + formatSaving(saving) + ' with this deal';
        saleTarget.insertAdjacentElement('afterend', savingMsg);
      }
    }
  }

  // --- Free shipping meter ---

  var FREE_SHIPPING_THRESHOLD = 75.00;

  // Re-entrancy guard: prevents our own DOM writes from re-triggering the observer
  var dcMeterUpdating = false;

  function parseCartTotal() {
    // Try the value attribute first (Shopify sets this reactively before updating text)
    var el = document.querySelector('.cart-totals__total-value');
    if (!el) return 0;
    var attrVal = el.getAttribute('value');
    if (attrVal) return parsePriceText(attrVal);
    return parsePriceText(el.textContent);
  }

  function buildShippingMeter() {
    var existing = document.getElementById('dc-free-shipping-meter');
    if (existing) return false; // already built

    var header = document.getElementById('cart-drawer-header');
    if (!header) return false;

    var wrapper = document.createElement('div');
    wrapper.className = 'dc-free-shipping-meter';
    wrapper.id = 'dc-free-shipping-meter';
    wrapper.innerHTML = [
      '<p class="dc-free-shipping-meter__label" id="dc-free-shipping-meter-label"></p>',
      '<div class="dc-free-shipping-meter__track">',
        '<div class="dc-free-shipping-meter__bar" id="dc-free-shipping-meter-bar"></div>',
      '</div>'
    ].join('');

    header.insertAdjacentElement('afterend', wrapper);
    return true; // just built
  }

  function updateShippingMeter() {
    var label = document.getElementById('dc-free-shipping-meter-label');
    var bar = document.getElementById('dc-free-shipping-meter-bar');
    if (!label || !bar) return;

    var current = parseCartTotal();
    var pct = Math.min((current / FREE_SHIPPING_THRESHOLD) * 100, 100);

    dcMeterUpdating = true;
    bar.style.width = pct + '%';

    if (current >= FREE_SHIPPING_THRESHOLD) {
      label.textContent = 'Your order qualifies for free shipping!';
      label.classList.add('dc-free-shipping-meter__label--qualified');
    } else {
      var remaining = (FREE_SHIPPING_THRESHOLD - current).toFixed(2);
      label.textContent = '\u00a3' + remaining + ' more for free shipping!';
      label.classList.remove('dc-free-shipping-meter__label--qualified');
    }
    dcMeterUpdating = false;
  }

  function initShippingMeter() {
    buildShippingMeter();
    updateShippingMeter();
  }

  initShippingMeter();

  // Watch for:
  // - childList: cart drawer being injected into the DOM
  // - attributes: Shopify updating the `value` attribute on cart-totals__total-value
  // - characterData: text node updates to the cart total
  // Re-entrancy guard (dcMeterUpdating) prevents our own label writes from looping.
  var lastCartTotalRaw = null;

  var shippingObserver = new MutationObserver(function (mutations) {
    // If we triggered this ourselves, ignore it
    if (dcMeterUpdating) return;

    var needsBuild = false;
    var needsUpdate = false;

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      // Skip mutations on our own meter
      var node = mutation.target;
      var insideMeter = false;
      var check = node;
      while (check && check !== document.body) {
        if (check.id === 'dc-free-shipping-meter') { insideMeter = true; break; }
        check = check.parentNode;
      }
      if (insideMeter) continue;

      if (mutation.type === 'childList') {
        // New nodes added — cart drawer may have opened
        needsBuild = true;
        needsUpdate = true;
      }

      if (mutation.type === 'attributes' || mutation.type === 'characterData') {
        // Cart total value changed
        needsUpdate = true;
      }
    }

    if (!needsBuild && !needsUpdate) return;

    // Throttle updates: only proceed if the raw cart total has actually changed,
    // or if we need to build the meter for the first time
    var cartEl = document.querySelector('.cart-totals__total-value');
    var rawVal = cartEl ? (cartEl.getAttribute('value') || cartEl.textContent.trim()) : null;

    if (needsBuild) buildShippingMeter();

    if (needsUpdate && rawVal !== lastCartTotalRaw) {
      lastCartTotalRaw = rawVal;
      updateShippingMeter();
    } else if (needsBuild) {
      // Meter was just built, populate it even if total hasn't "changed"
      lastCartTotalRaw = rawVal;
      updateShippingMeter();
    }
  });

  shippingObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value', 'data-cart-subtotal'],
    characterData: true
  });

});